// generated from 52_496 samples

import { z } from "zod";

export const attributeUpdatedTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::AttributeUpdated"),
  // null: 493 (0.94%)
  // true 49 (0.09%), false 51_954 (99.91%)
  blocklisted: z.boolean().nullable().optional(),
  // null: 493 (0.94%)
  // true 120 (0.23%), false 51_883 (99.77%)
  hard_deleted: z.boolean().nullable().optional(),
  // null: 432 (0.82%)
  klass: z
    .enum([
      "String", // 25_985 (49.91%)
      "TrueClass", // 7_886 (15.15%)
      "Integer", // 7_160 (13.75%)
      "FalseClass", // 5_569 (10.70%)
      "Time", // 4_544 (8.73%)
      "Hash", // 831 (1.60%)
      "Float", // 89 (0.17%)
    ])
    .nullable(),
  // null: 4 (0.01%)
  name: z.string(),
  // null: 51_672 (98.43%)
  path: z.string().nullable(),
  value: z.union([
    // null samples: 17_557 (33.44%)
    z.null(),
    // boolean samples: 12_725 (24.24%)
    // true 11_463 (90.08%), false 1_262 (9.92%)
    z.boolean(),
    // number samples: 3_815 (7.27%)
    // integer: 3_806 (99.76%)
    // avg: 1622896.65, min: -19, max: 5800000000
    z.number(),
    // string samples: 18_399 (35.05%)
    z.string(),
  ]),
});
